import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { trim } from 'lodash'
import workOrderService from '../services/workOrder.service'
import workOrderApi, { WorkOrderData } from '../apis/workOrder.api'
import Card from '../components/Card'
import InputText from '../components/InputText'
import PageHeading from '../components/PageHeading'
import SearchPicker, { SearchPickerOption } from '../components/SearchPicker'
import InputScan from '../components/InputScan'

interface LabelTraceFormProps {
  onScan: (workOrderId: number, lineNumber: string, code: string) => void
}

interface LabelTraceFormState {
  workOrder: string
  workOrderId: number | null
  lineNumber: string
  code: string
  workOrders: WorkOrderData[]
}

export default class LabelTraceForm
  extends Component<LabelTraceFormProps, LabelTraceFormState> {
  constructor (props: LabelTraceFormProps) {
    super(props)
    this.state = {
      workOrder: '',
      workOrderId: null,
      lineNumber: '',
      code: '',
      workOrders: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleInputScan = this.handleInputScan.bind(this)
    this.handleWorkOrderSearch = this.handleWorkOrderSearch.bind(this)
    this.handleWorkOrderSelect = this.handleWorkOrderSelect.bind(this)
    this.handleWorkOrderBlur = this.handleWorkOrderBlur.bind(this)
  }

  get workOrderOptions () {
    return workOrderService.searchOptions(this.state.workOrders)
  }

  handleInputChange (name: string, value: string) {
    if (name === 'workOrder') {
      this.setState({ workOrderId: null, workOrder: value })
    } else if (name === 'lineNumber') {
      this.setState({ lineNumber: value })
    } else if (name === 'code') {
      this.setState({ code: value })
    }
  }

  handleInputScan (name: string, value: string) {
    if (!trim(value)) return
    if (name === 'code') {
      const { workOrderId, lineNumber } = this.state
      if (!workOrderId) return
      this.props.onScan(workOrderId, lineNumber, value)
      this.setState({ code: '' })
    }
  }

  handleWorkOrderSearch (name: string, term: string) {
    workOrderApi.searchByCode(term, workOrders => {
      if (!workOrders) return
      this.setState({ workOrders })
    })
  }

  handleWorkOrderSelect (name: string, option: SearchPickerOption) {
    const workOrderId = option.id as number
    this.setState({ workOrderId, workOrders: [] })
  }

  handleWorkOrderBlur () {
    this.setState({ workOrders: [] })
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Label Trace")}
          doc='label-traces' />
        <SearchPicker
          name="workOrder"
          value={this.state.workOrder}
          label={i18n("Work order")}
          options={this.workOrderOptions}
          onSearch={this.handleWorkOrderSearch}
          onChange={this.handleInputChange}
          onSelect={this.handleWorkOrderSelect}
          onBlur={this.handleWorkOrderBlur} />
        <InputText
          name="lineNumber"
          value={this.state.lineNumber}
          label={i18n("Line number")}
          onChange={this.handleInputChange} />
        <InputScan
          name="code"
          value={this.state.code}
          label={i18n("Scan barcode")}
          onChange={this.handleInputChange}
          onScan={this.handleInputScan} />
      </Card>
    )
  }
}
